var map = {
	"./_ASEAN.png": 59188,
	"./_African Union(OAS).png": 40805,
	"./_Arab League.png": 78279,
	"./_CARICOM.png": 32546,
	"./_CIS.png": 95431,
	"./_Commonwealth.png": 86986,
	"./_European Union.png": 50980,
	"./_Islamic Conference.png": 76986,
	"./_Kosovo.png": 88307,
	"./_NATO.png": 55626,
	"./_Northern Cyprus.png": 72928,
	"./_Northern Ireland.png": 50741,
	"./_OPEC.png": 94631,
	"./_Olimpic Movement.png": 3162,
	"./_Red Cross.png": 97581,
	"./_Somaliland.png": 56852,
	"./_United Nations.png": 83655,
	"./_england.png": 29767,
	"./_scotland.png": 18174,
	"./_wales.png": 59384,
	"./ad.png": 62,
	"./ae.png": 87751,
	"./af.png": 19276,
	"./ag.png": 2165,
	"./ai.png": 99163,
	"./al.png": 41046,
	"./am.png": 19135,
	"./an.png": 89220,
	"./ao.png": 31725,
	"./aq.png": 39891,
	"./ar.png": 94136,
	"./as.png": 15265,
	"./at.png": 97550,
	"./au.png": 26775,
	"./aw.png": 51557,
	"./az.png": 6864,
	"./ba.png": 32706,
	"./bb.png": 97241,
	"./bd.png": 26831,
	"./be.png": 4166,
	"./bf.png": 29053,
	"./bg.png": 7924,
	"./bh.png": 50195,
	"./bi.png": 94986,
	"./bj.png": 43969,
	"./bm.png": 7854,
	"./bn.png": 79653,
	"./bo.png": 50236,
	"./br.png": 74025,
	"./bs.png": 2848,
	"./bt.png": 54175,
	"./bw.png": 99524,
	"./by.png": 55962,
	"./bz.png": 86129,
	"./ca.png": 21609,
	"./cd.png": 47108,
	"./cf.png": 5430,
	"./cg.png": 1759,
	"./ch.png": 19496,
	"./ci.png": 33713,
	"./ck.png": 4771,
	"./cl.png": 74604,
	"./cm.png": 60053,
	"./cn.png": 92702,
	"./co.png": 11015,
	"./cr.png": 80290,
	"./cu.png": 76637,
	"./cv.png": 51750,
	"./cy.png": 91553,
	"./cz.png": 42570,
	"./de.png": 71052,
	"./dj.png": 75067,
	"./dk.png": 53522,
	"./dm.png": 20260,
	"./do.png": 51734,
	"./dz.png": 17099,
	"./ec.png": 42061,
	"./ee.png": 52027,
	"./eg.png": 51817,
	"./eh.png": 22302,
	"./er.png": 27188,
	"./es.png": 48317,
	"./et.png": 86594,
	"./fi.png": 50710,
	"./fj.png": 41389,
	"./fm.png": 59826,
	"./fo.png": 53792,
	"./fr.png": 61221,
	"./ga.png": 6725,
	"./gb.png": 87950,
	"./gd.png": 98328,
	"./ge.png": 71041,
	"./gg.png": 72819,
	"./gh.png": 77524,
	"./gi.png": 98653,
	"./gl.png": 4112,
	"./gm.png": 19865,
	"./gn.png": 5858,
	"./gp.png": 23468,
	"./gq.png": 35093,
	"./gr.png": 98366,
	"./gt.png": 10888,
	"./gu.png": 42929,
	"./gw.png": 72867,
	"./gy.png": 58298,
	"./hk.png": 2366,
	"./hn.png": 14435,
	"./hr.png": 6460,
	"./ht.png": 54489,
	"./hu.png": 57584,
	"./id.png": 42150,
	"./ie.png": 81167,
	"./il.png": 59630,
	"./im.png": 88855,
	"./in.png": 47100,
	"./iq.png": 61243,
	"./ir.png": 6208,
	"./is.png": 77385,
	"./it.png": 3126,
	"./je.png": 89806,
	"./jm.png": 76774,
	"./jo.png": 36852,
	"./jp.png": 41699,
	"./ke.png": 65301,
	"./kg.png": 32039,
	"./kh.png": 30944,
	"./ki.png": 9065,
	"./km.png": 82957,
	"./kn.png": 68982,
	"./kp.png": 14744,
	"./kr.png": 94794,
	"./kw.png": 36887,
	"./ky.png": 26777,
	"./kz.png": 43842,
	"./la.png": 13776,
	"./lb.png": 79179,
	"./lc.png": 15522,
	"./li.png": 7992,
	"./lk.png": 31722,
	"./lr.png": 37147,
	"./ls.png": 15602,
	"./lt.png": 45581,
	"./lu.png": 82340,
	"./lv.png": 67615,
	"./ly.png": 20552,
	"./ma.png": 47751,
	"./mc.png": 92341,
	"./md.png": 40282,
	"./me.png": 30115,
	"./mg.png": 177,
	"./mh.png": 61398,
	"./mk.png": 93165,
	"./ml.png": 63186,
	"./mm.png": 84731,
	"./mn.png": 87168,
	"./mo.png": 11369,
	"./mq.png": 35191,
	"./mr.png": 46460,
	"./ms.png": 63973,
	"./mt.png": 56925,
	"./mu.png": 30067,
	"./mv.png": 55576,
	"./mw.png": 28289,
	"./mx.png": 72134,
	"./my.png": 57231,
	"./mz.png": 34772,
	"./na.png": 51814,
	"./nc.png": 16340,
	"./ne.png": 45122,
	"./ng.png": 94960,
	"./ni.png": 69294,
	"./nl.png": 11635,
	"./no.png": 65880,
	"./np.png": 90879,
	"./nr.png": 3469,
	"./nz.png": 73909,
	"./om.png": 71857,
	"./pa.png": 94476,
	"./pe.png": 81896,
	"./pf.png": 43875,
	"./pg.png": 54042,
	"./ph.png": 6925,
	"./pk.png": 75158,
	"./pl.png": 25129,
	"./pr.png": 48951,
	"./ps.png": 58958,
	"./pt.png": 42049,
	"./pw.png": 93066,
	"./py.png": 48532,
	"./qa.png": 76531,
	"./re.png": 74134,
	"./ro.png": 52364,
	"./rs.png": 56304,
	"./ru.png": 13158,
	"./rw.png": 77684,
	"./sa.png": 43289,
	"./sb.png": 29282,
	"./sc.png": 92939,
	"./sd.png": 948,
	"./se.png": 22077,
	"./sg.png": 23407,
	"./si.png": 94465,
	"./sk.png": 96243,
	"./sl.png": 12636,
	"./sm.png": 30149,
	"./sn.png": 11374,
	"./so.png": 1367,
	"./sr.png": 29362,
	"./st.png": 96100,
	"./sv.png": 27574,
	"./sy.png": 66353,
	"./sz.png": 6458,
	"./tc.png": 75658,
	"./td.png": 60325,
	"./tg.png": 88526,
	"./th.png": 77913,
	"./tj.png": 34507,
	"./tl.png": 9725,
	"./tm.png": 88596,
	"./tn.png": 23855,
	"./to.png": 84838,
	"./tr.png": 37859,
	"./tt.png": 93141,
	"./tv.png": 44103,
	"./tw.png": 25790,
	"./tz.png": 61851,
	"./ua.png": 4591,
	"./ug.png": 14969,
	"./us.png": 17229,
	"./uy.png": 73255,
	"./uz.png": 4780,
	"./va.png": 13230,
	"./vc.png": 88796,
	"./ve.png": 70634,
	"./vg.png": 90584,
	"./vi.png": 198,
	"./vn.png": 2617,
	"./vu.png": 17370,
	"./ws.png": 60311,
	"./ye.png": 38623,
	"./za.png": 93882,
	"./zm.png": 95766,
	"./zw.png": 88156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36838;